import styled from 'styled-components';

export const DisclaimerTextContainer = styled.div`
  display: flex;
  text-align: center;
  justify-content: center;

  p {
    font-size: 10px;
    color: #4c4c4c;
  }
`;
